/* ==========================================================================
   DRIONA — Custom Design builder
   Multi-step guided brief on top of Shopify's native contact form.
   No dependencies. Safe to load twice (guarded).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__DJC_BUILDER__) return;
  window.__DJC_BUILDER__ = true;

  var STORAGE_KEY = 'djc-brief-v2';

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); }

  // Field names contain brackets and spaces (contact[Piece type]) — match by
  // property rather than a selector so no CSS escaping is needed.
  function byName(root, name) {
    return $$('input, select, textarea', root).filter(function (el) { return el.name === name; });
  }

  function smoothTo(el, offset) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (offset || 80);
    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, top); }
  }

  /* --------------------------------------------------------- option state */
  // Radios/checkboxes live inside <label> tiles; mirror :checked onto the label.
  function paintGroup(form, input) {
    if (!input || !input.name) return;
    byName(form, input.name).forEach(function (el) {
      var label = el.closest('[data-djc-opt]');
      if (label) label.classList.toggle('is-checked', el.checked);
    });
  }

  function paintAll(form) {
    $$('input[type="radio"], input[type="checkbox"]', form).forEach(function (el) {
      var label = el.closest('[data-djc-opt]');
      if (label) label.classList.toggle('is-checked', el.checked);
    });
  }

  /* ------------------------------------------------------------ collected */
  function collect(form) {
    var out = [];
    $$('[data-djc-key]', form).forEach(function (el) {
      if (el.disabled) return; // field does not apply to the chosen piece
      var key = el.getAttribute('data-djc-key');
      var val = '';

      if (el.type === 'radio' || el.type === 'checkbox') {
        if (!el.checked) return;
        val = el.value;
        var existing = out.filter(function (r) { return r.key === key; })[0];
        if (existing) { existing.value += ', ' + val; return; }
      } else {
        val = (el.value || '').trim();
      }

      if (!val) return;
      out.push({ key: key, value: val, summary: el.getAttribute('data-djc-nosummary') !== 'true' });
    });
    return out;
  }

  /* -------------------------------------------------------------- summary */
  function renderSummary(form) {
    var list = $('[data-djc-summary-list]');
    var empty = $('[data-djc-summary-empty]');
    if (!list) return;

    var rows = collect(form).filter(function (r) { return r.summary; });
    list.innerHTML = '';

    if (!rows.length) {
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    rows.forEach(function (r) {
      if (r.key === 'Attachments') {
        var n = r.value.split('\n').filter(Boolean).length;
        r.value = n === 1 ? '1 file' : n + ' files';
      }
      var li = document.createElement('li');
      var k = document.createElement('span');
      var v = document.createElement('span');
      k.className = 'djc-summary__k';
      v.className = 'djc-summary__v';
      k.textContent = r.key;
      v.textContent = r.value.length > 42 ? r.value.slice(0, 42) + '…' : r.value;
      li.appendChild(k);
      li.appendChild(v);
      list.appendChild(li);
    });
  }

  /* ------------------------------------------------------------- storage */
  function save(form) {
    try {
      var data = {};
      $$('[data-djc-key]', form).forEach(function (el) {
        if (el.disabled) return;
        if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.checked) data[el.name + '::' + el.value] = true;
        } else if (el.value) {
          data[el.name] = el.value;
        }
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* private mode — ignore */ }
  }

  function restore(form) {
    var data;
    try { data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return; }
    if (!data || typeof data !== 'object') return;

    $$('[data-djc-key]', form).forEach(function (el) {
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (data[el.name + '::' + el.value]) el.checked = true;
      } else if (data[el.name] && !el.value) {
        el.value = data[el.name];
      }
    });
  }

  function clearSaved() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
  }

  /* ----------------------------------------------------------- the brief */
  // The Meta pixel on this store wraps forms and re-submits them with
  // form.submit(), which never fires a submit event. So the hidden body field
  // is kept current on every change instead of being composed at submit time.
  function buildBody(form) {
    var vision = $('[data-djc-vision]', form);
    var lines = [];

    if (vision && vision.value.trim()) {
      lines.push(vision.value.trim());
      lines.push('');
    }

    lines.push('--- DESIGN BRIEF ---');
    collect(form).forEach(function (r) {
      if (r.key === 'Your vision') return;
      lines.push(r.key + ': ' + r.value);
    });
    lines.push('--- sent from the custom design builder ---');

    var body = $('[data-djc-body]', form);
    if (body) body.value = lines.join('\n');
  }

  /* ------------------------------------------------- piece-aware fields */
  // Step 3 asks different questions for a ring, a necklace, earrings and a
  // bracelet. Fields that do not apply are hidden AND disabled so they never
  // reach the enquiry email.
  function applyPiece(form) {
    var chosen = null;
    $$('input[name="contact[Piece]"]', form).forEach(function (el) {
      if (el.checked) chosen = el.getAttribute('data-djc-piece') || '';
    });

    $$('[data-djc-for]', form).forEach(function (group) {
      var allowed = (group.getAttribute('data-djc-for') || '').split(/\s+/);
      var show = !chosen || allowed.indexOf(chosen) !== -1;
      group.classList.toggle('djc-hidden', !show);
      $$('input, select, textarea', group).forEach(function (field) {
        field.disabled = !show;
        if (!show) {
          if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = false;
            var label = field.closest('[data-djc-opt]');
            if (label) label.classList.remove('is-checked');
          } else {
            field.value = '';
          }
        }
      });
    });
  }

  /* ------------------------------------------------------------- uploads */
  // Shopify's contact form silently drops file inputs, so files go straight to
  // Cloudinary from the browser and only the resulting links are submitted.
  function initUpload(root, onChange) {
    if (!root || root.__djcReady) return;
    root.__djcReady = true;

    var cloud = root.getAttribute('data-cloud');
    var preset = root.getAttribute('data-preset');
    var max = parseInt(root.getAttribute('data-max'), 10) || 5;
    var maxBytes = (parseInt(root.getAttribute('data-maxmb'), 10) || 40) * 1024 * 1024;
    var input = $('[data-djc-file]', root);
    var list = $('[data-djc-upload-list]', root);
    var store = $('[data-djc-uploads]', root);
    var drop = $('[data-djc-drop]', root);
    var items = [];

    function sync() {
      store.value = items
        .filter(function (i) { return i.url; })
        .map(function (i) { return i.url; })
        .join('\n');
      if (onChange) onChange();
    }

    function row(item) {
      var el = document.createElement('div');
      el.className = 'djc-file';
      el.innerHTML =
        '<span class="djc-file__thumb"></span>' +
        '<span class="djc-file__meta"><span class="djc-file__name"></span>' +
        '<span class="djc-file__state">Uploading…</span></span>' +
        '<button type="button" class="djc-file__x" aria-label="Remove">&times;</button>';
      el.querySelector('.djc-file__name').textContent = item.file.name;
      if (/^image\//.test(item.file.type)) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(item.file);
        el.querySelector('.djc-file__thumb').appendChild(img);
      } else {
        el.querySelector('.djc-file__thumb').textContent = '▶';
      }
      el.querySelector('.djc-file__x').addEventListener('click', function () {
        items = items.filter(function (i) { return i !== item; });
        el.remove();
        sync();
      });
      list.appendChild(el);
      return el;
    }

    function upload(file) {
      if (items.length >= max) return;
      if (file.size > maxBytes) {
        var warn = document.createElement('p');
        warn.className = 'djc-upload__warn';
        warn.textContent = file.name + ' is too large (max ' + Math.round(maxBytes / 1048576) + 'MB).';
        list.appendChild(warn);
        return;
      }

      var item = { file: file, url: null };
      items.push(item);
      var el = row(item);
      var state = el.querySelector('.djc-file__state');

      var data = new FormData();
      data.append('file', file);
      data.append('upload_preset', preset);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cloud + '/auto/upload');
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) state.textContent = Math.round((e.loaded / e.total) * 100) + '%';
      };
      xhr.onload = function () {
        var ok = false;
        try {
          var res = JSON.parse(xhr.responseText);
          if (res.secure_url) { item.url = res.secure_url; ok = true; }
        } catch (err) { /* fall through to the error state */ }
        state.textContent = ok ? 'Added' : 'Upload failed';
        el.classList.add(ok ? 'is-done' : 'is-error');
        sync();
      };
      xhr.onerror = function () {
        state.textContent = 'Upload failed';
        el.classList.add('is-error');
      };
      xhr.send(data);
    }

    input.addEventListener('change', function () {
      Array.prototype.slice.call(input.files).forEach(upload);
      input.value = '';
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      drop.addEventListener(evt, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      drop.addEventListener(evt, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) {
        Array.prototype.slice.call(e.dataTransfer.files).forEach(upload);
      }
    });
  }

  /* --------------------------------------------------------------- steps */
  function initForm(form) {
    if (!form || form.__djcReady) return;
    form.__djcReady = true;

    var panes = $$('.djc-pane', form);
    var bar = $('[data-djc-bar]', form);
    var label = $('[data-djc-progress-label]', form);
    var titleEl = $('[data-djc-step-title]', form);
    var hintEl = $('[data-djc-step-hint]', form);
    var nextBtn = $('[data-djc-next]', form);
    var backBtn = $('[data-djc-back]', form);
    var submitBtn = $('[data-djc-submit]', form);
    var errorEl = $('[data-djc-error]', form);
    var card = form.closest('.djc-card') || form;
    var index = 0;

    if (!panes.length) return;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-shown');
      smoothTo(card, 100);
    }
    function hideError() {
      if (errorEl) errorEl.classList.remove('is-shown');
    }

    function validate(pane) {
      var need = (pane.getAttribute('data-djc-required') || '').split(',').filter(Boolean);
      for (var i = 0; i < need.length; i++) {
        var name = need[i].trim();
        var fields = byName(pane, name);
        if (!fields.length) continue;

        var filled = fields.some(function (f) {
          if (f.type === 'radio' || f.type === 'checkbox') return f.checked;
          return (f.value || '').trim() !== '';
        });
        if (!filled) {
          showError(pane.getAttribute('data-djc-message') || 'Please complete this step to continue.');
          return false;
        }
        if (fields[0].type === 'email' && !isEmail(fields[0].value)) {
          showError('Please enter a valid email address so we can send your quote.');
          fields[0].focus();
          return false;
        }
      }
      hideError();
      return true;
    }

    function render(scroll) {
      panes.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });

      var pane = panes[index];
      var pct = Math.round(((index + 1) / panes.length) * 100);
      if (bar) bar.style.width = pct + '%';
      if (label) label.textContent = 'Step ' + (index + 1) + ' of ' + panes.length;
      if (titleEl) titleEl.textContent = pane.getAttribute('data-djc-title') || '';
      if (hintEl) {
        hintEl.textContent = pane.getAttribute('data-djc-hint') || '';
        hintEl.style.display = pane.getAttribute('data-djc-hint') ? '' : 'none';
      }

      if (backBtn) backBtn.hidden = index === 0;
      var last = index === panes.length - 1;
      // The theme sets display on every <button> with !important, so an inline
      // display:none does nothing here — a class with !important is the only
      // thing that wins.
      if (nextBtn) nextBtn.classList.toggle('djc-hidden', last);
      if (submitBtn) submitBtn.classList.toggle('djc-hidden', !last);

      if (scroll) smoothTo(card, 90);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!validate(panes[index])) return;
        if (index < panes.length - 1) { index++; render(true); }
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        hideError();
        if (index > 0) { index--; render(true); }
      });
    }

    // Jump straight to a step from the summary rail / deep link.
    $$('[data-djc-goto]', document).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var n = parseInt(el.getAttribute('data-djc-goto'), 10);
        if (!isNaN(n) && n >= 1 && n <= panes.length) { index = n - 1; render(true); }
      });
    });

    form.addEventListener('change', function (e) {
      if (e.target && (e.target.type === 'radio' || e.target.type === 'checkbox')) paintGroup(form, e.target);
      if (e.target && e.target.name === 'contact[Piece]') applyPiece(form);
      renderSummary(form);
      buildBody(form);
      save(form);
    });

    form.addEventListener('input', function () {
      renderSummary(form);
      buildBody(form);
      save(form);
    });

    // Picking a tile on a single-choice step moves things along without a click.
    // A label click fires twice (once for the label, once for the input it
    // activates), so guard against advancing two steps at a time.
    var advancing = false;
    form.addEventListener('click', function (e) {
      var opt = e.target.closest ? e.target.closest('[data-djc-advance]') : null;
      if (!opt || advancing) return;
      advancing = true;
      setTimeout(function () {
        if (index < panes.length - 1 && validate(panes[index])) { index++; render(true); }
        advancing = false;
      }, 180);
    });

    form.addEventListener('submit', function (e) {
      if (!validate(panes[panes.length - 1])) {
        e.preventDefault();
        return;
      }
      var hp = $('[data-djc-hp]', form);
      if (hp && hp.value) { e.preventDefault(); return; } // bot
      buildBody(form);
      clearSaved();
      if (submitBtn) {
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.textContent = 'Sending…';
      }
    });

    restore(form);
    paintAll(form);
    applyPiece(form);
    initUpload($('[data-djc-upload]', form), function () {
      renderSummary(form);
      buildBody(form);
    });
    renderSummary(form);
    buildBody(form);
    render(false);
  }

  /* ------------------------------------------------------------ sticky bar */
  function initSticky() {
    var bar = $('[data-djc-sticky]');
    var builder = $('#dj-builder');
    if (!bar) return;

    function update() {
      var past = window.pageYOffset > 420;
      var inBuilder = false;
      if (builder) {
        var r = builder.getBoundingClientRect();
        inBuilder = r.top < window.innerHeight * 0.75 && r.bottom > 120;
      }
      bar.classList.toggle('is-shown', past && !inBuilder);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* --------------------------------------------------------------- misc */
  function initScrollLinks() {
    $$('[data-djc-scroll]').forEach(function (a) {
      if (a.__djcBound) return;
      a.__djcBound = true;
      a.addEventListener('click', function (e) {
        var target = $(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        smoothTo(target, 70);
        var first = $('.djc-pane.is-active [data-djc-opt] input', target);
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      });
    });
  }

  function initAccordions() {
    $$('[data-djc-q]').forEach(function (q) {
      if (q.__djcBound) return;
      q.__djcBound = true;
      var btn = $('.djc-q__btn', q);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = q.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function boot() {
    $$('[data-djc-form]').forEach(initForm);
    initSticky();
    initScrollLinks();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', boot);
})();
